"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useField_1 = require("../hooks/useField");
var shared_1 = require("@formily/shared");
var context_1 = require("../context");
exports.Field = function (props) {
    var _a = useField_1.useField(props), state = _a.state, field = _a.field, innerProps = _a.props, mutators = _a.mutators, form = _a.form;
    if (!state.visible || !state.display)
        return react_1.default.createElement(react_1.default.Fragment, null);
    if (shared_1.isFn(props.children)) {
        return (react_1.default.createElement(context_1.FieldContext.Provider, { value: field }, props.children({
            form: form,
            state: state,
            props: innerProps,
            mutators: mutators
        })));
    }
    else {
        return (react_1.default.createElement(context_1.FieldContext.Provider, { value: field }, props.children));
    }
};
exports.Field.displayName = 'ReactInternalField';
exports.Field.defaultProps = {
    path: '',
    triggerType: 'onChange'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/components/Field.js
// module id = 2071
// module chunks = 0